class CollectionTracker {
  constructor() {
    this.collectionPattern = /\/collections\/([^\/]+)/;
    this.productPattern = /\/products\/([^\/\?]+)/; // Updated to handle query params
    this.storageKey = "lastVisitedCollection";
    this.pageSessionKey = "collectionTrackerPageSession";
    this.init();
  }

  init() {
    // Track page session to detect navigation
    this.trackPageSession();

    // Check current page type and take appropriate action
    if (this.isProductPage()) {
      if (this.isTargetProductPage()) {
        this.updateBreadcrumbs();
      } else {
        // Product page without our target class - clear storage
        this.clearCollectionData();
      }
    } else if (this.isCollectionPage()) {
      this.storeCollectionInfo();
    } else {
      // Not a collection or product page - clear storage
      this.clearCollectionData();
    }
  }

  trackPageSession() {
    // Generate a unique ID for this page session
    const currentPageSession = Date.now().toString();
    const lastPageSession = sessionStorage.getItem(this.pageSessionKey);

    // Store current session
    sessionStorage.setItem(this.pageSessionKey, currentPageSession);

    // If lastPageSession exists and is different, it means user navigated from another page
    if (lastPageSession && lastPageSession !== currentPageSession) {
      // If navigated from another page and current page is not a product continuation of collection flow
      if (!this.isProductPage() || !this.isTargetProductPage()) {
        // Not continuing the collection->product flow, clear collection data
        this.clearCollectionData();
      }
    }
  }

  isCollectionPage() {
    return this.collectionPattern.test(window.location.href);
  }

  isProductPage() {
    return this.productPattern.test(window.location.href);
  }

  isTargetProductPage() {
    return document.body.classList.contains("product-line-specs--template");
  }

  clearCollectionData() {
    localStorage.removeItem(this.storageKey);
  }

  storeCollectionInfo() {
    const match = window.location.href.match(this.collectionPattern);
    if (match && match[1]) {
      const collectionSlug = match[1];
      const collectionName = this.getCollectionNameFromPage();
      if (collectionName) {
        // Store both slug and display name
        const collectionData = {
          slug: collectionSlug,
          name: collectionName,
          url: window.location.pathname,
          timestamp: Date.now(), // For freshness checking
        };

        localStorage.setItem(this.storageKey, JSON.stringify(collectionData));
      }
    }
  }

  getCollectionNameFromPage() {
    // Try to get a proper collection name from the page
    const headingElement = document.querySelector(
      ".collection-title-for-breadcrumb"
    );
    return headingElement ? headingElement.textContent.trim() : '';
  }

  formatCollectionSlug(slug) {
    // Basic slug to readable name conversion
    return slug
      .split("-")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }

  updateBreadcrumbs() {
    const breadcrumbsList = document.querySelector("nav.breadcrumbs ol");
    if (!breadcrumbsList) return;

    // Get stored collection data
    const storedDataString = localStorage.getItem(this.storageKey);
    if (!storedDataString) return;

    try {
      const collectionData = JSON.parse(storedDataString);
      const isPresentCollection = productCollectionList.includes(
        collectionData.slug
      );

      if (!isPresentCollection) return;

      // Check if data is fresh
      if (Date.now() - collectionData.timestamp >= 24 * 60 * 60 * 1000) {
        this.clearCollectionData();
        return;
      }

      // Keep only the first breadcrumb (Home)
      const homeItem = breadcrumbsList.querySelector("li:first-child");
      if (!homeItem) return;

      // Remove all other breadcrumbs
      Array.from(
        breadcrumbsList.querySelectorAll("li:not(:first-child)")
      ).forEach((item) => item.remove());

      // Create and append collection breadcrumb
      const collectionItem = document.createElement("li");
      collectionItem.innerHTML = `<a href="${collectionData.url}" title="${collectionData.name}">See more ${collectionData.name} for sale</a>`;
      breadcrumbsList.appendChild(collectionItem);
    } catch (e) {
      console.error("Error updating breadcrumbs:", e);
      this.clearCollectionData();
    }
  }
}


// Initialize immediately and also handle navigation events
(() => {
  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      () => new CollectionTracker()
    );
  } else {
    new CollectionTracker();
  }
})();



class GtagButtonTracker {
  constructor(baseSelector) {
    this.baseSelector = baseSelector;
    this.handleClick = this.handleClick.bind(this);
    this.init();
  }

  init() {
    document.addEventListener("click", this.handleClick, false);
  }

  handleClick(event) {
    // Look for any ancestor (or self) with the class
    const candidate = event.target.closest(this.baseSelector);
    if (!candidate) {
      return;
    }

    const onclickAttr = candidate.getAttribute("onclick") || "";
    if (!onclickAttr.includes("GRFQApp.popup.submitQuote")) {
      return;
    }

    this.trackConversion();

    // Track GA4 raq event with matching condition
    if (typeof gtag === "function") {
      console.log("[GtagButtonTracker] Sending GA4 raq event...");
      gtag("event", "raq", {
        event_name: "raq-submit"
      });
    } else {
      console.warn("[GtagButtonTracker] gtag() is not defined – cannot send GA4 raq event.");
    }
  }

  trackConversion() {
    if (typeof gtag === "function") {
      console.log("[GtagButtonTracker] Sending gtag conversion event...");
      gtag("event", "conversion", {
        send_to: "AW-11060477570/S6KrCLCNndQaEIL9hZop",
      });
    } else {
      console.warn(
        "[GtagButtonTracker] gtag() is not defined – cannot send conversion event."
      );
    }
  }
}

// Wait until DOM is fully parsed, then start tracking.
document.addEventListener("DOMContentLoaded", () => {
  new GtagButtonTracker(".grfq__popupForm__buttonPrimary");
  // new GtagButtonTracker(".rfq-btn");

  // Listen for postMessage from the iframe
  window.addEventListener("message", (event) => {
    if (event.data && event.data.type === "IFRAME_FORM_SUBMIT") {
      console.log("[Parent] Received form-submit message from iframe.");

      // Fire GA4 event
      if (typeof gtag === "function") {
        gtag("event", "form_submit", {
          event_category: "iframe_form",
          event_label: "Cross-origin iframe submitted",
        });

        // Fire Ads conversion
        gtag("event", "conversion", {
          send_to: "AW-11060477570/jgybCPHvkNQaEIL9hZop",
        });
      } else {
        console.warn("[Parent] gtag() is not defined – cannot track iframe submission.");
      }
    }
  });

  // GA4 conversion for the StrykerPro PDP quick-quote embed. Both embeds
  // re-dispatch a single window-level "stryker:lead_submitted" event on a
  // successful submit, so we attach exactly one listener. The cross-iframe
  // event payload is intentionally bare (no product data), so the product
  // enrichment is read from the .stryker-pdp-embed div's data-* attributes.
  window.addEventListener("stryker:lead_submitted", function () {
    if (typeof gtag !== "function") return;

    var embed = document.querySelector(".stryker-pdp-embed[data-shopify-product-id]");

    var params = {
      form_name: "strykertrailer_product_inquiry",
      page_location: window.location.href,
    };

    if (embed) {
      var itemId = embed.getAttribute("data-shopify-product-id");
      var itemName = embed.getAttribute("data-stryker-item-name");
      var itemVariant = embed.getAttribute("data-stryker-variant");
      var price = embed.getAttribute("data-stryker-price");

      if (itemId) params.item_id = itemId;
      if (itemName) params.item_name = itemName;
      if (itemVariant) params.item_variant = itemVariant;
      if (price) params.value = Number(price);
    }

    gtag("event", "PDP_form_submit", params);
  });
});
